// extracted by mini-css-extract-plugin
export default {"base":"FormResponse_base__qX4rV","title":"FormResponse_title__jbgFs","text":"FormResponse_text__pVRHV"};